<script>
    import Icon from 'svelte-awesome';
    import { caretRight, caretDown } from 'svelte-awesome/icons'
    import { queryGetItemsWithSources } from '../../../stores/helpers';
    import SourceItemCheckboxComponent from './SourceItemCheckboxComponent.svelte';

    export let source;
    export let checked;
    export let displayItemSet;
    export let filteredItems;
    export let clickSource;
    export let clickCaret;
    export let clickItem;

    function getUniqueLinks(items) {
        const seen = {}
        return items.filter(item => {
            if (!(item.link in seen)) {
                seen[item.link] = 1;
                return item;
            }
        })
    }

    $: [sourceName,] = source;
    $: shouldDisplayItems = displayItemSet[sourceName];
    $: items = getUniqueLinks(queryGetItemsWithSources([sourceName]));
    $: displayedItems = shouldDisplayItems ? items : [];
</script>

{#if source}
<div>
    <div style="display:flex;padding:10px 0;">
        <input style="width:16px;height:16px;margin:0;" type="checkbox" value={sourceName} id="{sourceName}" on:change={(e) => clickSource(e.target.checked, sourceName)} checked={checked}>
        <label style="padding-left:8px;" for="{sourceName}">{sourceName} - ({items.length})</label>
        <div on:click={clickCaret(sourceName)} style="width:24px;display:flex;align-items:center;justify-content:center;">
            {#if shouldDisplayItems}
                <Icon data={caretDown} scale={1} />
            {:else}
                <Icon data={caretRight} scale={1} />
            {/if}
        </div>
    </div>

    {#if shouldDisplayItems}

        {#each displayedItems as item}
            <SourceItemCheckboxComponent
                item={item}
                sourceName={sourceName}
                filteredItems={filteredItems}
                clickItem={clickItem}
            />
        {/each}
    {/if}
</div>
{/if}